import React from "react";
import { Col, Row } from "react-bootstrap";
import AboutChildAbout from "./AboutChild/AboutChild_About";
import aboutImg from "../Assets/Images/personal-infothumb-2653662e.png";
import AboutChildEducation from "./AboutChild/AboutChild_Education";
import AboutChildAwards from "./AboutChild/AboutChild_Awards";
import AboutChildInterests from "./AboutChild/AboutChild_Interests";
import AboutChildLanguages from "./AboutChild/AboutChild_Languages";
import AboutChildCertificates from "./AboutChild/AboutChild_Certificates";
import AboutChildExperise from "./AboutChild/AboutChild_Experise";
const NewAboutChild = (props) => {
  return (
    <>
      <Row>
        <Col md={6} className="new-abot-left-img">
          <img src={aboutImg} alt="about illustration" loading="lazy" />
        </Col>
        <Col md={6}>
          {props.type === "About" && <AboutChildAbout type={props.type} />}
          {props.type === "Education" && (
            <AboutChildEducation type={props.type} />
          )}
          {props.type === "Awards" && <AboutChildAwards type={props.type} />}
          {props.type === "Interests" && <AboutChildInterests type={props.type} />}
          {props.type === "Languages" && <AboutChildLanguages type={props.type} />}
          {props.type === "Certificates" && <AboutChildCertificates type={props.type} />}
          {props.type === "Expertise" && <AboutChildExperise type={props.type} />}
        </Col>
      </Row>
    </>
  );
};

export default NewAboutChild;
